import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Header } from '../../models/header.model';
import { CookieNgrxModule, CookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ButtonModule } from '@teamfoster/sdk/button';
import { IconComponent } from '@teamfoster/sdk/icon';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-header-library',
  standalone: true,
  imports: [CookieNgrxModule, StripEmbedPipe, ButtonModule, IconComponent, ResizeHtmlImagesPipe, SafePipe, NgOptimizedImage],
  templateUrl: './header-library.component.html',
  styleUrl: './header-library.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLibraryComponent {
  header = input.required<Header>();
  cookiePreferences = input<CookiePreferences>();

  // 3 random items if there are more than 3 items
  randomImages = computed(() => {
    if (!this.header()?.images) {
      return [];
    }

    const images = [...this.header().images!];
    return images?.sort(() => 0.5 - Math.random()).slice(0, 3) || [];
  });
}
